// extracted by mini-css-extract-plugin
module.exports = {"title":"Community_title__17RNP","text":"Community_text__2PQb1","subTitle":"Community_subTitle__1bCB3","listTitle":"Community_listTitle__2_PPR"};